import _ from "lodash";

export default {
    created() {
        //TODO: Load metadata
    },
    data() {
        return {
            WI_TYPE_USER_STORY: "User Story",
            WI_TYPE_BUG: "BUG",
            WI_TYPE_TASK: "Task",
            WI_TYPE_DEFECT: "DEFECT",
            WI_STATE_NEW: "New",
            WI_STATE_TODO: "To Do",
            WI_STATE_INPROGRESS: "In Progress",
            WI_STATE_DONE: "Done",
            WI_STATE_REMOVED: "Removed",
            US_STATE_COMMITTED: "Committed",
            US_STATE_READYFORDEV: "Ready for Development",
            TIME_ITEM_TYPE_WORK: 0,
            TIME_ITEM_TYPE_ACTIVITY: 1,
            TIME_ITEM_TYPE_ABSENCE: 2,
            AZURE_DAILY_CAPACITY_HOURS: 8
        };
    },
    methods: {
        addChangeResetSupport: function (obj, savedIndicatorProp, keys) {
            function normalizeValue(value) {
                if (value === "" || value === null || typeof value === "undefined")
                    return "";
                if (typeof value === "number" || (typeof value === "string" && value.trim() !== "" && !isNaN(value)))
                    return Number(value);
                return value;
            }
            function areObjectsTheSame(obj1, obj2) {
                if (!obj1 || !obj2) return obj1 === obj2;
                for (const key of keys) {
                    if (key === 'customFields') {
                        const cf1 = obj1.customFields || {};
                        const cf2 = obj2.customFields || {};
                        const allKeys = _.union(Object.keys(cf1), Object.keys(cf2));
                        for (const cfKey of allKeys) {
                            if (normalizeValue(cf1[cfKey]) !== normalizeValue(cf2[cfKey])) {
                                return false;
                            }
                        }
                        continue;
                    }
                    if (!_.some(Object.keys(obj1), k => k === key) || !_.some(Object.keys(obj2), k => k === key)
                        || normalizeValue(obj1[key]) !== normalizeValue(obj2[key])) {
                        return false;
                    }
                }
                return true;
            }
            function isChanged(target) {
                let obj1 = _.pick(target, keys);
                let obj2 = target.stashedData;
                return !areObjectsTheSame(obj1, obj2);
            }
            function isSaved(target) {
                let indicator = target[savedIndicatorProp];
                return typeof indicator !== "undefined" && indicator !== null;
            }
            let extenderItem = {
                stashedData: {},

                canSave() {
                    return isChanged(this);
                },
                canReset() {
                    return isChanged(this);
                },
                canDeleteLog() {
                    return !isSaved(this) || !isChanged(this);
                },
                canDeleteTask() {
                    return !isSaved(this) || !isChanged(this);
                },
                isModifying() {
                    return isChanged(this);
                },
                isSaved() {
                    return isSaved(this);
                },
                loadStash() {
                    let original = _.pick(this, keys);
                    this.stashedData = _.cloneDeep(original);
                },
                resetStash() {
                    const clone = _.cloneDeep(this.stashedData);
                    _.assign(this, clone);
                    if (clone.customFields) {
                        this.customFields = _.cloneDeep(clone.customFields);
                    }
                    this.loadStash();
                }
            };

            _.assign(obj, extenderItem);
        },
        addStateSupport: function (obj) {
            let extenderItem = {
                state: "",
                isOfState: function (...states) {
                    return this.state && _.some(states, s => this.state.toLowerCase() == s.toLowerCase());
                }
            };
            _.assign(obj, extenderItem);
        },
        addStateInternalStateSupport: function (obj) {
            this.addStateSupport(obj);
        },
        getVariantBgColor: function (variant) {
            let result = "";
            switch (variant) {
                case "primary": result = "007bff"; break;
                case "secondary": result = "6c757d"; break;
                case "success": result = "28a745"; break;
                case "danger": result = "dc3545"; break;
                case "warning": result = "ffc107"; break;
                case "info": result = "17a2b8"; break;
                case "light": result = "f8f9fa"; break;
                case "dark": result = "343a40"; break;
            }
            return result;
        },
        getVariantColor: function (variant) {
            let result = "";
            switch (variant) {
                case "primary": 
                case "secondary":
                case "success":
                case "danger":
                case "info":
                case "dark":
                    result = "fff";
                    break;
                case "warning":
                case "light":
                    result = "000";
                    break;                    
            }
            return result;
        },
        actionHoverPop: function (title) {
            return {
                title,
                container: "body",
                offset: "0, 8",
                customClass: "action-hover-pop",
                boundary: "window"
            };
        }
    }
};
